export const TON_PROTOCOL = 'ion://';
export const ION_GATEWAY_PROTOCOL = 'ion-gateway://';
export const ION_GATEWAY_PROTOCOL_SELF = 'ion-gateway://';
export const SELF_PROTOCOL = 'ion://';
export const SELF_UNIVERSAL_URLS = ['https://web.ionwallet.io', 'https://wallet.ice.io', 'https://go.wallet.ice.io'];
export const ION_GATEWAY_UNIVERSAL_URL = 'https://connect.ionwallet.io';
export const CHECKIN_URL = 'https://wallet.ice.io/checkin';
export const WALLETCONNECT_PROTOCOL = 'wc:';
export const WALLETCONNECT_DEEPLINK = 'ion-wc://';
export const WALLETCONNECT_UNIVERSAL_URLS = ['https://connect.ionwallet.io/wc'];
